const getters = {
	TOKEN: state => state.user.TOKEN,
	USER_INFO: state => state.user.USER_INFO,
    STOP_REQUEST: state => state.user.STOP_REQUEST,
}

export default getters;